function loadContentToggles() {
  let toggles = document.querySelectorAll('.content-toggle > button')
  toggles.forEach(function(toggle) {
    let sibling = toggle.nextElementSibling
    let hiddenClass = '+display-none'
    // set content to hidden after page load
    sibling.classList.add(hiddenClass)
    toggle.onclick = function() {
      if (sibling.classList.contains(hiddenClass)) {
        sibling.classList.remove(hiddenClass)
      } else {
        sibling.classList.add(hiddenClass)
      }
    }
  })
}

setTimeout(loadContentToggles, 1000)
